import {
  KProperty1ca4yb4wlo496 as KProperty1,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  get_mainPageNavigator29w1pddlp5wea as get_mainPageNavigator,
  set_pageNavigator2t8ucpwsozusv as set_pageNavigator,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import {
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  get_unpadded3gipn3ftxgnwh as get_unpadded,
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  Frame1e7t2kcdb3wu7 as Frame,
  RowOrCol3a33s3yce2tuv as RowOrCol,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { pwaInstallAvailabilityCheck1bnae6eqkhryw as pwaInstallAvailabilityCheck } from '../../../actuals/pwaCheck.js.mjs';
import { set_overlayFrame2h1srqihqvjg5 as set_overlayFrame } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/AppNavV2.mjs';
import { DialogHandler190bym9acvxfj as DialogHandler } from '../../screens/common/DialogWithDialog.mjs';
import { println2shhhgwwt4c61 as println } from '../../../../../../kotlin-kotlin-stdlib/kotlin/io/console.mjs';
import {
  reactive2pl1t9wy5gll5 as reactive,
  reactiveScope1fcalsbdr0hgb as reactiveScope,
} from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { navigatorViewDialog3c3cfw7xfbjq8 as navigatorViewDialog } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/NavigatorView.mjs';
import {
  get_dp28ag147e4p5cz as get_dp,
  get_rem2p56fiaxda5jo as get_rem,
  get_px8ok5q0jdway2 as get_px,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  BarSemantic_getInstance5oimrhs7x11g as BarSemantic_getInstance,
  NavSemantic_getInstance3ooa6be5xy9hs as NavSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  crowpayNavHeaderWide309ruo66u7u86 as crowpayNavHeaderWide,
  crowpayNavHeaderNarrow3nv75bwx6kil4 as crowpayNavHeaderNarrow,
} from './header.mjs';
import { get_expanding10cuv3ua9vajx as get_expanding } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  crowpaySideNavjkfnjr6prypg as crowpaySideNav,
  crowpayBottomNav2jsedy4v8rkye as crowpayBottomNav,
} from './navigation.mjs';
import { MobileNavSemantic_getInstance35ah13hrpn1em as MobileNavSemantic_getInstance } from '../../theming/appTheme.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { shownWhenxgf1ujy6rmvr as shownWhen } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { greySeparatory5mpcoeivng5 as greySeparator } from '../../theming/separators.mjs';
import { SwapView1526g6cz7z56r as SwapView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/SwapView.commonHtml.mjs';
import { applySafeInsets3lsxkfxcwtdd8 as applySafeInsets } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/safeInsetsHelpers.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { get_rawSession1kjo1nj4tz6n0 as get_rawSession } from '../../../sdk/UserSession.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import {
  firstOrNull1982767dljvdy as firstOrNull,
  joinToString1cxrrlmo0chqs as joinToString,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  report1vfr9zf0i9d9p as report,
  Companion_getInstanceok5aued8gko9 as Companion_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/debugger.mjs';
import { AuthScreen1ogng2fnfjgd9 as AuthScreen } from '../../screens/auth/LogInScreen.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { AppState_getInstance1lcg5jamx8e1g as AppState_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/AppState.js.mjs';
import {
  Companion_getInstance3ks9yb1iyfxr2 as Companion_getInstance_0,
  get_AppDimensions1ckwvsuun6046 as get_AppDimensions,
} from './AppDimensions.mjs';
import { Dimension__compareTo_impl_gsceod2qehgbisv77nv as Dimension__compareTo_impl_gsceod } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForFunctionReferencen3g5fpj34t8u as initMetadataForFunctionReference,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  closePopovers89geeulkriez as closePopovers,
  rContextAddonGenerate29u6cpzj8mq24 as rContextAddonGenerate,
  rContextAddonInit1l0t8s3axt11t as rContextAddonInit,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/ViewContextExtensions.mjs';
import { onRemove3k528udkni1ni as onRemove } from '../../../../../../reactive/com/lightningkite/reactive/context/CalculationContext.mjs';
import {
  h22716j86ehrvde as h2,
  text1v7b2bj2gx49v as text,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { listOfNotNull2woi2boe01ub4 as listOfNotNull } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { smallBody2trfy14zwtona as smallBody } from '../../theming/Titles.mjs';
import { LsErrorException1ikb4g50zc2ko as LsErrorException } from '../../../../../../lightning-server-kiteui-client/com/lightningkite/lightningserver/LsErrorException.mjs';
import { stackTraceToString2670q6lbhdojj as stackTraceToString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/throwableExtensions.mjs';
import { truncate3gvhc1a2is66m as truncate } from '../../../utils/utils.mjs';
import {
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
  get_secondaryButtondor94xxt3ws3 as get_secondaryButton,
} from '../../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { dialog2nk0sz8wudj8p as dialog } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/popoverHelpers.mjs';
import {
  Companion_getInstance3vz87v4c01z2t as Companion_getInstance_1,
  toDuration7gy6v749ektt as toDuration,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_SECONDS_getInstance3jias9ne5z4er as DurationUnit_SECONDS_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { delay1diib1rb84y4j as delay } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { awaitOnce2ui7qqi9bvdeq as awaitOnce } from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { LandingScreennv9edtrim3be as LandingScreen } from '../../screens/common/LandingScreen.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { ViewWriter2xfqkrnuqv5cx as ViewWriter } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/ViewWriter.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { UnauthorizedLensException1mhjkh9rtctj7 as UnauthorizedLensException } from '../../screens/common/ProjectView.mjs';
import { trimIndent1qytc1wvt8suh as trimIndent } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Indent.mjs';
import { GenericDialog2kroovzplfo3s as GenericDialog } from '../../dialogs/GenericDialog.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { Edges2jf5wl855ambv as Edges } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Rect.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_navExists(_this__u8e3s4) {
  _init_properties_crowpay_kt__d19yox();
  var tmp = KProperty1();
  return navExists$delegate.oam(_this__u8e3s4, getPropertyCallableRef('navExists', 1, tmp, _get_navExists_$ref_2n4shr(), null));
}
var navExists$delegate;
function get_windowIsNarrow() {
  _init_properties_crowpay_kt__d19yox();
  return windowIsNarrow;
}
var windowIsNarrow;
function get_pwaInstallAvailable() {
  _init_properties_crowpay_kt__d19yox();
  return pwaInstallAvailable;
}
var pwaInstallAvailable;
function set_viewIsNarrow(_this__u8e3s4, _set____db54di) {
  _init_properties_crowpay_kt__d19yox();
  var tmp = KMutableProperty1();
  var tmp_0 = _get_viewIsNarrow_$ref_l4trf4_0();
  return viewIsNarrow$delegate.qam(_this__u8e3s4, getPropertyCallableRef('viewIsNarrow', 1, tmp, tmp_0, _set_viewIsNarrow_$ref_7yahno_0()), _set____db54di);
}
function get_viewIsNarrow(_this__u8e3s4) {
  _init_properties_crowpay_kt__d19yox();
  var tmp = KMutableProperty1();
  var tmp_0 = _get_viewIsNarrow_$ref_l4trf4();
  return viewIsNarrow$delegate.oam(_this__u8e3s4, getPropertyCallableRef('viewIsNarrow', 1, tmp, tmp_0, _set_viewIsNarrow_$ref_7yahno()));
}
var viewIsNarrow$delegate;
function get_viewIsWide(_this__u8e3s4) {
  _init_properties_crowpay_kt__d19yox();
  return !get_viewIsNarrow(_this__u8e3s4);
}
function navigateOrDialog(_this__u8e3s4, page) {
  _init_properties_crowpay_kt__d19yox();
  var tmp;
  if (get_viewIsNarrow(_this__u8e3s4)) {
    get_mainPageNavigator(_this__u8e3s4).dbw(page);
    tmp = Unit_instance;
  } else {
    get_dialogStack().xgd(page);
    tmp = Unit_instance;
  }
  return tmp;
}
function set_dialogStack(_set____db54di) {
  _init_properties_crowpay_kt__d19yox();
  dialogStack = _set____db54di;
}
function get_dialogStack() {
  _init_properties_crowpay_kt__d19yox();
  var tmp = dialogStack;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('dialogStack');
  }
}
var dialogStack;
function crowpay(_this__u8e3s4) {
  _init_properties_crowpay_kt__d19yox();
  var tmp = get_unpadded(_this__u8e3s4);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Frame())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  pwaInstallAvailabilityCheck();
  set_overlayFrame(view, view);
  set_dialogStack(new (DialogHandler())(view));
  view.tba(new (crowpay$1())());
  view.tba(new (crowpay$2())(view));
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (Frame())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  var $this$frame = view_0;
  reactive($this$frame, ($this$reactive) => {
    println('rerendering stoze');
    $this$frame.zb9();
    var tmp;
    if ($this$reactive.baj(get_windowIsNarrow())) {
      println('narrow');
      set_viewIsNarrow($this$frame, true);
      tmp = crowpayNarrow($this$frame);
    } else {
      println('wide');
      set_viewIsNarrow($this$frame, false);
      tmp = crowpayWide($this$frame);
    }
    return tmp;
  });
  view.fbb(p_0, view_0);
  navigatorViewDialog(view);
  _this__u8e3s4.fbb(p, view);
  return _this__u8e3s4.jbb(tmp, view);
}
function crowpayWide(_this__u8e3s4) {
  _init_properties_crowpay_kt__d19yox();
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  view.zb8(get_dp(0));
  // Inline function 'com.lightningkite.kiteui.views.bar' call
  var tmp$ret$0 = view.hbb(BarSemantic_getInstance());
  view.jbb(tmp$ret$0, crowpayNavHeaderWide(view));
  var tmp = get_expanding(view);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xbm(false);
  // Inline function 'com.lightningkite.kiteui.views.nav' call
  var tmp$ret$1 = view_0.hbb(NavSemantic_getInstance());
  view_0.jbb(view_0.ibb(tmp$ret$1, sizeConstraints(view_0, get_rem(12))), crowpaySideNav(view_0));
  view_0.jbb(get_expanding(view_0), crowpayNavigatorView(view_0, get_mainPageNavigator(view_0)));
  view.fbb(p_0, view_0);
  view.jbb(tmp, view_0);
  _this__u8e3s4.fbb(p, view);
  return view;
}
function crowpayNarrow(_this__u8e3s4) {
  _init_properties_crowpay_kt__d19yox();
  var tmp = _this__u8e3s4.hbb(MobileNavSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  var $this$col = view;
  $this$col.zb8(get_px(0));
  var tmp_0 = shownWhen($this$col, VOID, ($this$shownWhen) => $this$shownWhen.baj(get_navExists($this$col)));
  // Inline function 'com.lightningkite.kiteui.views.bar' call
  var tmp$ret$0 = $this$col.hbb(BarSemantic_getInstance());
  $this$col.jbb($this$col.ibb(tmp_0, tmp$ret$0), crowpayNavHeaderNarrow($this$col));
  $this$col.bbn(get_rem(1));
  $this$col.jbb($this$col.ibb(get_expanding($this$col), get_unpadded($this$col)), crowpayNavigatorView($this$col, get_mainPageNavigator($this$col)));
  $this$col.jbb(shownWhen($this$col, VOID, ($this$shownWhen) => $this$shownWhen.baj(get_navExists($this$col))), greySeparator($this$col));
  var tmp_1 = shownWhen($this$col, VOID, ($this$shownWhen) => $this$shownWhen.baj(get_navExists($this$col)));
  // Inline function 'com.lightningkite.kiteui.views.nav' call
  var tmp$ret$1 = $this$col.hbb(NavSemantic_getInstance());
  $this$col.jbb($this$col.ibb(tmp_1, tmp$ret$1), crowpayBottomNav($this$col));
  _this__u8e3s4.fbb(p, view);
  return _this__u8e3s4.jbb(tmp, view);
}
function crowpayNavigatorView(_this__u8e3s4, navigator) {
  _init_properties_crowpay_kt__d19yox();
  // Inline function 'com.lightningkite.kiteui.views.direct.swapView' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (SwapView())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  var $this$swapView = view;
  var lastStack = {_v: navigator.gbn_1.f2()};
  reactive($this$swapView, ($this$reactive) => {
    var tmp;
    if ($this$reactive.baj(get_windowIsNarrow())) {
      applySafeInsets($this$swapView, false, false, false, false);
      tmp = Unit_instance;
    } else {
      applySafeInsets($this$swapView, false, false);
      tmp = Unit_instance;
    }
    return Unit_instance;
  });
  // Inline function 'com.lightningkite.kiteui.views.direct.swapping' call
  var this_0 = $this$swapView;
  var queue = ArrayList().w();
  var alreadySwapping = {_v: false};
  reactiveScope(this_0, ($this$reactiveScope) => {
    var c = to($this$reactiveScope.baj(navigator.hbn_1), !($this$reactiveScope.baj(get_rawSession()) == null));
    queue.v(c);
    var tmp;
    if (alreadySwapping._v) {
      return Unit_instance;
    }
    alreadySwapping._v = true;
    $l$loop: while (true) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!!queue.i1()) {
        break $l$loop;
      }
      var next = queue.z3(0);
      try {
        var newStack = navigator.gbn_1.f2();
        var transitionSet = $this$swapView.kba().rb0_1;
        // Inline function 'kotlin.also' call
        var this_1 = (newStack.p1() - lastStack._v.p1() | 0) > 0 ? transitionSet.pbb_1 : (newStack.p1() - lastStack._v.p1() | 0) < 0 && equals(firstOrNull(newStack), firstOrNull(lastStack._v)) ? transitionSet.qbb_1 : transitionSet.rbb_1;
        lastStack._v = newStack;
        var tmp_0 = this_1;
        this_0.rci(tmp_0, crowpayNavigatorView$lambda$lambda(next, navigator));
      } catch ($p) {
        if ($p instanceof Exception()) {
          var e = $p;
          report(Exception().vd('Failed to render ' + toString(next), e), 'SwapView.swapping');
        } else {
          throw $p;
        }
      }
    }
    alreadySwapping._v = false;
    return Unit_instance;
  });
  _this__u8e3s4.fbb(p, view);
  return view;
}
function navExists$delegate$lambda($this$rContextAddonGenerate) {
  _init_properties_crowpay_kt__d19yox();
  return remember(VOID, VOID, VOID, ($this$remember) => {
    var tmp;
    if (!($this$remember.baj(get_rawSession()) == null)) {
      var tmp_0 = $this$remember.baj(get_mainPageNavigator($this$rContextAddonGenerate).hbn_1);
      tmp = !(!(tmp_0 == null) ? isInterface(tmp_0, AuthScreen()) : false);
    } else {
      tmp = false;
    }
    return tmp;
  });
}
function _get_navExists_$ref_2n4shr() {
  return (p0) => get_navExists(p0);
}
function windowIsNarrow$lambda($this$remember) {
  _init_properties_crowpay_kt__d19yox();
  return Dimension__compareTo_impl_gsceod($this$remember.baj(AppState_getInstance().mbi()).ebi_1, Companion_getInstance_0().rgf_1) < 0;
}
function _get_viewIsNarrow_$ref_l4trf4() {
  return (p0) => get_viewIsNarrow(p0);
}
function _set_viewIsNarrow_$ref_7yahno() {
  return (p0, p1) => {
    set_viewIsNarrow(p0, p1);
    return Unit_instance;
  };
}
function _get_viewIsNarrow_$ref_l4trf4_0() {
  return (p0) => get_viewIsNarrow(p0);
}
function _set_viewIsNarrow_$ref_7yahno_0() {
  return (p0, p1) => {
    set_viewIsNarrow(p0, p1);
    return Unit_instance;
  };
}
function handle$_anonymous_$_anonymous_$label_j5vl2u(_this__u8e3s4, label) {
  return isBlank(_this__u8e3s4) ? null : label + ': ' + _this__u8e3s4;
}
function crowpay$o$handle$lambda() {
  return Unit_instance;
}
var crowpay$o$handle$lambda$slambdaClass;
function crowpay$o$handle$lambda$slambda() {
  if (crowpay$o$handle$lambda$slambdaClass === VOID) {
    class $ {
      constructor($closer, $action, $view) {
        this.lgg_1 = $closer;
        this.mgg_1 = $action;
        this.ngg_1 = $view;
      }
      sao($completion) {
        this.lgg_1();
        this.mgg_1.xbe(this.ngg_1);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    crowpay$o$handle$lambda$slambdaClass = $;
  }
  return crowpay$o$handle$lambda$slambdaClass;
}
function crowpay$o$handle$lambda$slambda_0($closer, $action, $view) {
  var i = new (crowpay$o$handle$lambda$slambda())($closer, $action, $view);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var crowpay$o$handle$lambda$slambdaClass_0;
function crowpay$o$handle$lambda$slambda_1() {
  if (crowpay$o$handle$lambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($closer) {
        this.ogg_1 = $closer;
      }
      sao($completion) {
        this.ogg_1();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    crowpay$o$handle$lambda$slambdaClass_0 = $;
  }
  return crowpay$o$handle$lambda$slambdaClass_0;
}
function crowpay$o$handle$lambda$slambda_2($closer) {
  var i = new (crowpay$o$handle$lambda$slambda_1())($closer);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function crowpay$o$handle$lambda_0() {
  return Unit_instance;
}
var crowpay$1Class;
function crowpay$1() {
  if (crowpay$1Class === VOID) {
    class $ {
      constructor() {
        this.pgg_1 = false;
      }
      i90() {
        return 0.01;
      }
      qcv(view, working, exception) {
        if (this.pgg_1) {
          Companion_getInstance().gcv(['Blocked ' + exception.toString() + '; already open']);
          return crowpay$o$handle$lambda;
        }
        this.pgg_1 = true;
        closePopovers(view);
        var message = ensureNotNull(view.yba(exception));
        dialog(view, VOID, ($this$dialog, closer) => {
          onRemove($this$dialog, () => {
            this.pgg_1 = false;
            return Unit_instance;
          });
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_0 = new (RowOrCol())($this$dialog.pc());
          var tmp0_elvis_lhs = $this$dialog.cbb_1;
          var p = tmp0_elvis_lhs == null ? $this$dialog : tmp0_elvis_lhs;
          $this$dialog.ebb(p, view_0);
          view_0.xbm(true);
          h2(view_0, message.rcv_1);
          text(view_0, message.scv_1);
          if (exception instanceof LsErrorException()) {
            var info = listOfNotNull([handle$_anonymous_$_anonymous_$label_j5vl2u(exception.udr_1.q4b_1.toString(), 'Error Code'), handle$_anonymous_$_anonymous_$label_j5vl2u(exception.udr_1.r4b_1, 'Detail'), handle$_anonymous_$_anonymous_$label_j5vl2u(exception.udr_1.t4b_1, 'Data')]);
            // Inline function 'kotlin.collections.isNotEmpty' call
            if (!info.i1()) {
              smallBody(view_0, joinToString(info, '\n'));
            }
          }
          smallBody(view_0, truncate(stackTraceToString(exception), 500));
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_1 = new (RowOrCol())(view_0.pc());
          var tmp0_elvis_lhs_0 = view_0.cbb_1;
          var p_0 = tmp0_elvis_lhs_0 == null ? view_0 : tmp0_elvis_lhs_0;
          view_0.ebb(p_0, view_1);
          view_1.xbm(false);
          var _iterator__ex2g4s = message.tcv_1.m1();
          while (_iterator__ex2g4s.n1()) {
            var action = _iterator__ex2g4s.o1();
            var tmp = get_primaryButton(view_1);
            // Inline function 'com.lightningkite.kiteui.views.direct.button' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_2 = new (Button())(view_1.pc());
            var tmp0_elvis_lhs_1 = view_1.cbb_1;
            var p_1 = tmp0_elvis_lhs_1 == null ? view_1 : tmp0_elvis_lhs_1;
            view_1.ebb(p_1, view_2);
            specCenteredText(view_2, action.ucv());
            onClick(view_2, VOID, VOID, crowpay$o$handle$lambda$slambda_0(closer, action, view));
            view_1.fbb(p_1, view_2);
            view_1.jbb(tmp, view_2);
          }
          var tmp_0 = get_secondaryButton(view_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_3 = new (Button())(view_1.pc());
          var tmp0_elvis_lhs_2 = view_1.cbb_1;
          var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
          view_1.ebb(p_2, view_3);
          specCenteredText(view_3, 'OK');
          onClick(view_3, VOID, VOID, crowpay$o$handle$lambda$slambda_2(closer));
          view_1.fbb(p_2, view_3);
          view_1.jbb(tmp_0, view_3);
          view_0.fbb(p_0, view_1);
          $this$dialog.fbb(p, view_0);
          return Unit_instance;
        });
        return crowpay$o$handle$lambda_0;
      }
    }
    initMetadataForClass($);
    crowpay$1Class = $;
  }
  return crowpay$1Class;
}
function *_generator_invoke__zhh2q8($this, $this$launch, $completion) {
  // Inline function 'kotlin.time.Companion.seconds' call
  Companion_getInstance_1();
  var tmp$ret$0 = toDuration(5, DurationUnit_SECONDS_getInstance());
  var tmp = delay(tmp$ret$0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = handle$dismiss($this.sgg_1.rgg_1, $this.tgg_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function *_generator_handle$dismiss__3vw4l6(_this__u8e3s4, dismissed, $completion) {
  if (dismissed._v)
    return Unit_instance;
  // Inline function 'kotlin.run' call
  var $this$run = get_mainPageNavigator(_this__u8e3s4);
  var tmp;
  var tmp_0 = awaitOnce($this$run.ibn_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  if (tmp_0) {
    tmp = $this$run.qd6();
  } else {
    $this$run.ebw(new (LandingScreen())());
    tmp = Unit_instance;
  }
  get_dialogStack().ugg();
  dismissed._v = true;
  return Unit_instance;
}
function handle$dismiss(_this__u8e3s4, dismissed, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_handle$dismiss__3vw4l6.bind(VOID, _this__u8e3s4, dismissed), $completion);
}
var crowpay$o$handle$dismiss$refClass;
function crowpay$o$handle$dismiss$ref() {
  if (crowpay$o$handle$dismiss$refClass === VOID) {
    class $ {
      constructor($dismissed) {
        this.vgg_1 = $dismissed;
      }
      wgg(p0, $completion) {
        return handle$dismiss(p0, this.vgg_1, $completion);
      }
      s2(p1, $completion) {
        return this.wgg(p1 instanceof ViewWriter() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForFunctionReference($, VOID, VOID, [1]);
    crowpay$o$handle$dismiss$refClass = $;
  }
  return crowpay$o$handle$dismiss$refClass;
}
function crowpay$o$handle$dismiss$ref_0($dismissed) {
  var i = new (crowpay$o$handle$dismiss$ref())($dismissed);
  var l = (p0, $completion) => i.wgg(p0, $completion);
  l.callableName = 'handle$dismiss';
  l.$arity = 1;
  return l;
}
var crowpay$o$handle$slambdaClass;
function crowpay$o$handle$slambda() {
  if (crowpay$o$handle$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $dismissed) {
        this.sgg_1 = this$0;
        this.tgg_1 = $dismissed;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    crowpay$o$handle$slambdaClass = $;
  }
  return crowpay$o$handle$slambdaClass;
}
function crowpay$o$handle$slambda_0(this$0, $dismissed) {
  var i = new (crowpay$o$handle$slambda())(this$0, $dismissed);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
function crowpay$o$handle$lambda_1() {
  return Unit_instance;
}
var crowpay$2Class;
function crowpay$2() {
  if (crowpay$2Class === VOID) {
    class $ {
      constructor($this_frame) {
        this.rgg_1 = $this_frame;
        this.qgg_1 = 5.0;
      }
      i90() {
        return this.qgg_1;
      }
      qcv(view, working, exception) {
        if (!(exception instanceof UnauthorizedLensException()))
          return null;
        var dismissed = {_v: false};
        var tmp = get_dialogStack();
        var tmp0_elvis_lhs = exception.message;
        var tmp_0 = trimIndent('\n                            ' + (tmp0_elvis_lhs == null ? 'You are not allowed to view this page' : tmp0_elvis_lhs) + ',\n                            This page will automatically close in 5 seconds.\n                        ');
        tmp.xgd(GenericDialog().bgh('Unauthorized', tmp_0, 'Go Back', crowpay$o$handle$dismiss$ref_0(dismissed)));
        launch(view, VOID, VOID, crowpay$o$handle$slambda_0(this, dismissed));
        return crowpay$o$handle$lambda_1;
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, VOID, [2]);
    crowpay$2Class = $;
  }
  return crowpay$2Class;
}
function crowpayNavigatorView$lambda$lambda($next, $navigator) {
  return ($this$swap) => {
    var destruct = $next;
    var screen = destruct.cf();
    var loggedIn = destruct.df();
    set_pageNavigator($this$swap, $navigator);
    var tmp;
    if (!(screen == null)) {
      // Inline function 'kotlin.with' call
      // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view = new (Frame())($this$swap.pc());
      var tmp0_elvis_lhs = $this$swap.cbb_1;
      var p = tmp0_elvis_lhs == null ? $this$swap : tmp0_elvis_lhs;
      $this$swap.ebb(p, view);
      var tmp_0;
      if (loggedIn) {
        tmp_0 = !isInterface(screen, AuthScreen());
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        var tmp_1;
        if (get_viewIsNarrow(view)) {
          var tmp0_vertical = get_dp(0);
          var tmp1_horizontal = get_AppDimensions().wg1_1;
          tmp_1 = Edges().cd0(tmp1_horizontal, tmp0_vertical);
        } else {
          tmp_1 = Edges().ad0(get_AppDimensions().wg1_1);
        }
        view.hba(tmp_1);
      }
      screen.ud6(view);
      $this$swap.fbb(p, view);
      tmp = view;
    } else {
      // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_0 = new (Frame())($this$swap.pc());
      var tmp0_elvis_lhs_0 = $this$swap.cbb_1;
      var p_0 = tmp0_elvis_lhs_0 == null ? $this$swap : tmp0_elvis_lhs_0;
      $this$swap.ebb(p_0, view_0);
      $this$swap.fbb(p_0, view_0);
      tmp = view_0;
    }
    return tmp;
  };
}
var properties_initialized_crowpay_kt_ertgkf;
function _init_properties_crowpay_kt__d19yox() {
  if (!properties_initialized_crowpay_kt_ertgkf) {
    properties_initialized_crowpay_kt_ertgkf = true;
    navExists$delegate = rContextAddonGenerate(navExists$delegate$lambda);
    // Inline function 'kotlin.time.Companion.seconds' call
    Companion_getInstance_1();
    var tmp = toDuration(1, DurationUnit_SECONDS_getInstance());
    windowIsNarrow = remember(VOID, true, tmp, windowIsNarrow$lambda);
    pwaInstallAvailable = Signal().fak(false);
    viewIsNarrow$delegate = rContextAddonInit();
  }
}
//region block: exports
export {
  crowpay as crowpay2qzi7x0waf7w5,
  get_dialogStack as get_dialogStackleaqvayyucjw,
  get_navExists as get_navExists2s7t7g61yra64,
  navigateOrDialog as navigateOrDialog1m0cnx3luzasq,
  get_pwaInstallAvailable as get_pwaInstallAvailable261a64jtq77ae,
  get_viewIsNarrow as get_viewIsNarrow26l63sh4olw2h,
  get_viewIsWide as get_viewIsWide3s4g60a9e0192,
  get_windowIsNarrow as get_windowIsNarrow3aab1t9rdaelq,
};
//endregion

//# sourceMappingURL=crowpay.mjs.map
